export interface IDiscountService {
  listDiscounts(cnpj: string): Promise<GasStationProduct>;
  createDiscount(
    cnpj: string,
    discount: NewDiscount
  ): Promise<DiscountResponse>;
}

export interface NewDiscount {
  productId: string;
  value: number;
  paymentMethod: string;
  userId: string;
}

export interface GasStationProduct {
  [key: string]: DiscountResponse[];
}

export interface DiscountResponse {
  id?: string;
  value?: number;
  paymentMethod?: string;
  userId?: string;
  createdAt?: string;
  updatedAt?: string;
  companyId?: string;
  deletedAt?: string;
  productId?: string;
  product: DiscountProductResponse;
}

export interface DiscountProductResponse {
  id: string;
  name: string;
  internal_code: string;
  unit: string;
  value?: string;
  createdAt: string;
  updatedAt: string;
  ean: string;
  deletedAt: string;
  ncm_id: string;
  company_id: string;
}

export interface Discount {
  discounts: MappedDiscount[];
  internalCode: string;
  value: string;
  unit: string;
  productId: string;
  description?: string;
}

export interface MappedDiscount {
  paymentMethod: string;
  discount: number;
  discountId: string;
}

export enum PaymentMethod {
  DEBIT = "Débito",
  MONEY = "Dinheiro",
  CREDIT = "Crédito",
  PIX = "Pix",
  FLEET = "Frota",
}
